var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgModalCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.295,
    height: 30.295,
    viewBox: "0 0 30.295 30.295",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circle-xmark-regular",
    d: "M15.147,2.84A12.307,12.307,0,1,1,2.84,15.147,12.307,12.307,0,0,1,15.147,2.84Zm0,27.455A15.147,15.147,0,1,0,0,15.147,15.147,15.147,0,0,0,15.147,30.295Zm-4.793-19.94a1.414,1.414,0,0,0,0,2.006l2.781,2.781-2.781,2.781a1.418,1.418,0,0,0,2.006,2.006l2.781-2.781,2.781,2.781a1.418,1.418,0,0,0,2.006-2.006l-2.781-2.781,2.781-2.781a1.418,1.418,0,0,0-2.006-2.006l-2.781,2.781L12.36,10.355A1.414,1.414,0,0,0,10.355,10.355Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/modal-close-icon.f86f23d2426c09dc423af6a3b37bd478.svg";
export { ForwardRef as ReactComponent };